// extracted by mini-css-extract-plugin
module.exports = {"root":"ShoppingCartButton_root__syMo8","cartIcon":"ShoppingCartButton_cartIcon__PMUZW","cartCounter":"ShoppingCartButton_cartCounter__S2bTK"};